import { Action } from '@ngrx/store';
import { LoginResponse } from 'src/app/shared/models/fusion-auth';
import { LoginViewModel } from 'src/app/shared/models/general';
import {HttpErrorResponse} from "@angular/common/http";

export enum FusionAuthActionTypes {
    LOGIN = '[Auth] Login',
    LOGIN_SUCCESS = '[Auth] Login Success',
    LOGIN_FAILURE = '[Auth] Login Failure',
    LOGOUT = '[Auth] Logout',
}

export class LogIn implements Action {
    public readonly type = FusionAuthActionTypes.LOGIN;
    constructor(public payload: LoginViewModel) {}
}

export class LogInSuccess implements Action {
    public readonly type = FusionAuthActionTypes.LOGIN_SUCCESS;
    constructor(public payload: LoginResponse) {}
}

export class LogInFailure implements Action {
    public readonly type = FusionAuthActionTypes.LOGIN_FAILURE;
    constructor(public payload: { error: HttpErrorResponse }) {}
}

export class LogOut implements Action {
    public readonly type = FusionAuthActionTypes.LOGOUT;
}

export type All = LogIn | LogInSuccess | LogInFailure | LogOut;
